export const geoCache = new Map();
export const pendingGeoRequests = new Map();
let identity;

export function clearGeoCache() {
   geoCache.clear();
   pendingGeoRequests.clear();
}

export function syncGeoIdentity() {
   const token = localStorage.getItem("token");
   if (token !== identity) {
      identity = token;
      clearGeoCache();
   }
}
